import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { delay } from 'rxjs';
import { ApplicationService } from './services/application.service';
import { LoadingService } from './services/loading-service';
import { NavigationService } from './services/navigation.service';
import { CacheService } from './services/cache.service';
import { AppConfigService } from './services/app-config.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'PPLApps';
  loading: boolean = false;
  displayErrorModal: string = 'none';
  errorModalMessage: string = 'none';
  maintenaceMode: boolean = false;


  constructor(
    private _loading: LoadingService,
    private activatedRoute: ActivatedRoute,
    private _navigationService: NavigationService,
    private _applicationService: ApplicationService,
    private _cacheService: CacheService,
    private _appConfig: AppConfigService,
  ){

    this.maintenaceMode = _appConfig.getAppConfig().maintenaceMode;
  }

  ngOnInit() {
    this.listenToLoading();

    this.activatedRoute.paramMap.subscribe(() => {
      this.activatedRoute.queryParams.subscribe((parameter) => {
        if(parameter['aplusLogout'] == 'True') {
          this._navigationService.logout();
        }
      });
    });

    this._applicationService.errorModalLaunch$.pipe().subscribe((errorModal) => {
      if (errorModal.errorLevel == '401') {
        errorModal.errorLevel = '';
        errorModal.respCode = '';
        errorModal.respDesc = '';
        this._applicationService.broadcastErrorModalLaunch(errorModal);
        this._cacheService.setItem('Expired', 'LogoutExpired');
      } else if (errorModal.errorLevel != '') {
        this.errorModalMessage = errorModal.respDesc;
        errorModal.errorLevel = '';
        errorModal.respCode = '';
        errorModal.respDesc = '';
        this._applicationService.broadcastErrorModalLaunch(errorModal);
        this.displayErrorModal = 'block';
      } else if (errorModal.respCode != '0' && errorModal.respCode != '') {
        this.errorModalMessage = errorModal.respDesc;
        errorModal.errorLevel = '';
        errorModal.respCode = '';
        errorModal.respDesc = '';
        this._applicationService.broadcastErrorModalLaunch(errorModal);
        this.displayErrorModal = 'block';
      }
    });


  }

  listenToLoading(): void {
    this._loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.loading = loading;
      });
  }

  launchModal(): void {
    this.displayErrorModal = "block";
  }

  navigateToDashboard(e: any): void {
    if (e) {
      this.displayErrorModal = 'none';
    }
  }
  

}
